module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-database-5.556893a1.svg";